import React, { useState, useEffect } from 'react';
import { Container, Table, Form, Alert, Spinner, Button } from 'react-bootstrap';
import Navbar from './Navbar';

const API_URL = process.env.REACT_APP_API_URL || "/";

const MisDiagramas = () => {
  const [mesTexto, setMesTexto] = useState('');
  const [resultados, setResultados] = useState([]);
  const [loading, setLoading] = useState(false);
  const usuario = JSON.parse(localStorage.getItem('user'));

  useEffect(() => {
    if (!usuario?.Legajo) return;
    buscarDiagramas(usuario.Legajo.toString());
  }, [usuario?.Legajo]);

  const nombresMes = [
    'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
    'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
  ];

  const extraerMesDesdeNombre = (nombre) => {
    const match = nombre.match(/^D(\d{4})(\d{2})\d+\.pdf$/);
    return match ? match[2] : null;
  };

  const obtenerNombreMes = (mes) => {
    return nombresMes[parseInt(mes, 10) - 1] || 'mes desconocido';
  };

  const buscarDiagramas = async (legajo) => {
    setLoading(true);

    try {
      await new Promise(resolve => setTimeout(resolve, 1500));

      const token = localStorage.getItem('token');
      const res = await fetch(`${API_URL}/api/diagramas/${legajo}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      const data = await res.json();

      if (data.success && Array.isArray(data.data)) {
        const todos = data.data.map((d) => {
          const mes = extraerMesDesdeNombre(d.nombre_archivo);
          return {
            nombre: d.nombre_archivo,
            url: `${API_URL}assets/Diagramas/${d.nombre_archivo}`,
            fecha: d.fecha_subida,
            mesNombre: obtenerNombreMes(mes),
            mesNumero: mes
          };
        });

        todos.sort((a, b) => parseInt(a.mesNumero) - parseInt(b.mesNumero));
        setResultados(todos);
      } else {
        setResultados([]);
      }
    } catch (error) {
      console.error('❌ Error al buscar diagramas:', error);
      setResultados([]);
    } finally {
      setLoading(false);
    }
  };

  // 🔍 Filtro dinámico por mes
  const resultadosFiltrados = resultados.filter(d => {
    if (!mesTexto.trim()) return true;
    return d.mesNombre.toLowerCase() === mesTexto.trim().toLowerCase();
  });

  const handleVer = (url) => {
    window.open(url, '_blank');
  };

  const handleDescargar = (url, nombre) => {
    const link = document.createElement('a');
    link.href = url;
    link.download = nombre;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div>
      <Navbar />
      <Container className="py-4">
        <h4 className="mb-3">Mis Diagramas de Servicio</h4>

        <Form.Group className="mb-4" controlId="mesTexto">
          <Form.Label>Filtrar por mes (en texto)</Form.Label>
          <Form.Control
            type="text"
            placeholder="Ej: marzo"
            value={mesTexto}
            onChange={(e) => setMesTexto(e.target.value)}
          />
        </Form.Group>

        {loading ? (
          <div className="text-center my-5">
            <Spinner animation="border" role="status" />
            <div className="mt-2">Cargando diagramas...</div>
          </div>
        ) : resultadosFiltrados.length === 0 ? (
          <Alert variant="warning">No se encontró ningún diagrama para ese mes.</Alert>
        ) : (
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Mes</th>
                <th>Nombre</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {resultadosFiltrados.map((d, idx) => (
                <tr key={idx}>
                  <td>{d.mesNombre}</td>
                  <td>{d.nombre}</td>
                  <td className="d-flex gap-2">
                    <Button variant="info" onClick={() => handleVer(d.url)}>
                      Ver PDF
                    </Button>
                    <Button variant="info" onClick={() => handleDescargar(d.url, d.nombre)}>
                      Descargar
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Container>
    </div>
  );
};

export default MisDiagramas;
